export default "__VITE_ASSET__CoY3O7TI__"